import React from "react";
import { Spinner } from "reactstrap";

const ContractCard = ({
  user,
  existSchoolContractCid,
  contractQuestion,
  handleContract,
  handleNoContract,
  BtnLoader,
  schoolAdminData,
}) => {
  if (!contractQuestion || !existSchoolContractCid) return null;

  return (
    <div className="saas-card" style={{ marginBottom: "24px", borderColor: "#6366f1", borderWidth: "2px" }}>
      <div className="card-header-saas" style={{ borderBottom: "none", marginBottom: "8px" }}>
        <h3 style={{ color: "#6366f1" }}>
          <i className="fas fa-file-contract mr-2"></i> School IP Contract Linking
        </h3>
      </div>
      
      <div style={{ fontSize: "0.9rem" }}>
        {user?.schoolAdminId ? (
          <div>
            <p style={{ fontWeight: 600, color: "#475569" }}>
              Your memento production can now use footage of sports from your school. Check with your coach or your school’s media Dept to access the footage.
            </p>
            <p style={{ fontSize: "0.8125rem", color: "#64748b", margin: 0 }}>
              School Admin Name: <strong>{schoolAdminData?.name}</strong>
            </p>
          </div>
        ) : (
          <div>
            <p style={{ fontWeight: 600, color: "#475569", marginBottom: "16px" }}>
              Do you wish to link your memento production to an IP contract with your school?
            </p>
            <div style={{ display: "flex", gap: "12px" }}>
              <button
                className="saas-btn primary"
                onClick={handleContract}
                disabled={BtnLoader}
              >
                {BtnLoader ? <Spinner size="sm" /> : "Yes, Link Contract"}
              </button>
              <button
                className="saas-btn secondary"
                onClick={handleNoContract}
                disabled={BtnLoader}
              >
                No
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractCard;
